import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import {
  ac1,
  ac2,
  ac3,
  ac4,
  ac5,
  ac6,
  ac7,
  ac8,
  ac9,
  ac10,
  ac11,
  ac12,
 


} from "../assets/images/index";

const AcPrice = () => {
  const products = [
    {
        _id: "1013",
        img: ac1,
        productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
        price: "134700",
        color: "HAIER",
        badge: true,
        des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
        _id: "1014",
        img: ac2,
        productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W ",
        price: "163800",
        color: "HAIER",
        badge: false,
        des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
          _id: "1015",
          img: ac3,
          productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S",
          price: "150900",
          color: "KENWOOD",
          badge: true,
          des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
        },
        {
          _id: "1016",
          img: ac4,
          productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2 ",
          price: "161700",
          color: "TCL",
          badge: false,
          des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
        },
        {
          _id: "1017",
          img: ac5,
          productName: "MIDEA 1.5 TON DC INVERTER EXTREME AC Model MSAGC-18HRFN1 ",
          price: "171300",
          color: "MIDEA",
          badge: true,
          des: "The MSAGC-18HRFN1 is a 1.5 Ton Inverter Wall Mounted air conditioner from Midea. It’s part of the Xtreme series and comes with Wi-Fi capabilities. This air conditioner is known for its energy efficiency and cost-effectiveness."
        },
        {
          _id: "1018",
          img: ac6,
          productName: "TCL 1.5 TON T-PRO DC INVERTER AC Model TAC 18T3 PRO ",
          price: "183300",
          color: "TCL",
          badge: false,
          des: "The TAC-18T3-Pro is a 1.5 Ton DC Inverter from TCL, an upgraded version of the TCL Miracle Series. It offers a completely controlled refreshment with IoT Wi-Fi, allowing you to adjust the temperature and turn the AC off or on at any time from anywhere. The Hands-Free Voice Control feature on your TCL TV also lets you control the AC."
        },
        {
            _id: "1019",
            img: ac7,
            productName: "GREE 1.5 TON PULAR SERIES INVERTER SPLIT AC Model GS-18PITH11 W",
            price: "183300",
            color: "GREE",
            badge: true,
            des: "The GREE Split AC 1.5 TON Pular Series GS-18PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
          },
          {
            _id: "1020",
            img: ac8,
            productName: "GREE 1.0 TON PULAR SERIES INVERTER SPLIT AC Model GS-12PITH11W ",
            price: "149700",
            color: "GREE",
            badge: false,
            des: "The GREE Split AC 1 TON Pular Series GS-12PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
          },
        {
          _id: "1021",
          img: ac9,
          productName: "KENWOOD 1.5 TON EECO ULTRA T3 INVERTER AC Model KEE-1865S",
          price: "204900",
          color: "KENWOOD",
          badge: true,
          des: "The Kenwood KEE-1865S eECO Ultra is a 1.5-ton full DC inverter air conditioner that offers efficient cooling and heating with T3 technology. It’s equipped with advanced features like 3D airflow, Wifi, and voice control, ensuring optimal comfort in any weather condition."
        },
        {
          _id: "1022",
          img: ac10,
          productName: "HAIER 1.0 TON HEAT & COOL DC INVERTER AC Model HSU-12HFCA W",
          price: "134700",
          color: "HAIER",
          badge: false,
          des: "The Triple Inverter HSU-12HFCA/013USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
        },
        {
          _id: "1023",
          img: ac11,
          productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
          price: "231900",
          color: "HAIER",
          badge: true,
          des: "The Triple Inverter HSU-24HFCD/012USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
        },
        {
          _id: "1024",
          img: ac12,
          productName: "MIDEA 1.0 TON BREEZELESS E INVERTER SPLIT AC Model MSCB1BU-12HRFN8  ",
          price: "146400",
          color: "MIDEA",
          badge: false,
          des: "The Midea Breezeless E combines sophistication and functionality with its innovative design. It features advanced inverter technology for precise temperature control and whisper-quiet operation."
        },
        {
          _id: "1013",
          img: ac1,
          productName: "HAIER  2.0 TON HEAT & COOL INVERTER WALL TYPE SPLIT AC Model HSU-24HFCD W",
          price: "134700",
          color: "HAIER",
          badge: true,
          des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
        },
        {
          _id: "1014",
          img: ac2,
          productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W",
          price: "163800",
          color: "HAIER",
          badge: false,
          des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
        },
        {
            _id: "1015",
            img: ac3,
            productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S ",
            price: "150900",
            color: "KENWOOD",
            badge: true,
            des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
          },
          {
            _id: "1016",
            img: ac4,
            productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2",
            price: "161700",
            color: "TCL",
            badge: false,
            des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
          },

         
    
  ];

  const downloadPDF = () => {
    const input = document.getElementById("price-list"); 
    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = pdf.internal.pageSize.height; 
    const pageWidth = pdf.internal.pageSize.width;
  
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      let yPosition = 0;
  
      while (yPosition < imgHeight) {
        pdf.addImage(imgData, "PNG", 0, -yPosition, imgWidth, imgHeight);
        yPosition += pageHeight; 
  
        if (yPosition < imgHeight) {
          pdf.addPage(); 
        }
      }
  
      pdf.save("price-list.pdf");
    });
  };
  return (
    <div className="max-w-container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-5">AC Price List</h1>
      <button
        onClick={downloadPDF}
        className="bg-dark text-white px-4 py-2 mb-5 rounded"
      >
        Download PDF
      </button>
      <div id="price-list" className="space-y-6">
        {products.map((product) => (
          <div
            key={product._id}
            className="flex items-start border rounded shadow p-5"
          >
            <img
              src={product.img}
              alt={product.productName}
              className="w-36 h-36 object-contain mr-5"
            />
            <div>
              <h2 className="text-xl font-semibold">{product.productName}</h2>
              <p className="text-gray-600 mt-2">{product.des}</p>
              <span className="text-lg font-bold mt-2 block">
                Rs.{product.price}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcPrice;
